import React, { useEffect, useState } from 'react';
import {
  renderCheckboxes,
  renderDropdownWithoutLabel,
  renderDropdownWithoutLabelMultiple,
  renderInputFieldWithoutLabel,
} from '../../../../common/inputField';
import { useDispatch, useSelector } from 'react-redux';
import {
  setEmbryologyBiopsyFiles,
  setEmbryologyData,
} from '../../../../actions/embryologyActions';
import { TextField } from '@mui/material';
import {
  fetchEmbryologyBiopsy,
  fetchEmbryologyTransferData,
} from '../../../../api/embryologyApi';
import { toast } from 'sonner';
import {
  embryoTransferredDataRow,
  emptyBiopsyRow,
} from '../../../../reducers/embryologyReducer';
import {
  updateFileStatusUploaded,
  uploadPatientFileApi,
} from '../../../../api/patientApi';
import { deleteFileApi } from '../../../../api/fileApi';
import FileDocumentCard from '../../../../components/FileManager/FileDocumentCard';
import FileUploadCard from '../../../../components/FileManager/FileUploadCard';
import CustomTextField from '../../../../common/CustomTextField';
import DateComponent from '../../../Registrationform/components/dateComponent';
import dayjs from 'dayjs';
import UIModal from '../../../../components/UIElements/UIModal';
import EmbryologyLiveBirthDetails from './EmbryologyLiveBirthDetails';
import EmbryologyClinicalPregDetails from './EmbryologyClinicalPregDetails';
import EmbryologyHormonalPregDetails from './EmbryologyHormonalPregDetails';
import EmbryologyET from './EmbryologyET';
import EmbryologyBasicTransferDetails from './EmbryologyBasicTransferDetails';
import EmbryologyDetailsWithEmbryologist from './EmbryologyDetailsWithEmbryologist';

const EmbryologyTransferDetails = ({ cycleId, isDisabled }) => {
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [confirmModal, setConfirmModal] = useState({
    open: false,
    index: null,
  });
  const data = useSelector((state) => state.embryologyReducer);
  const embryoTransferDetails = useSelector(
    (state) => state.embryologyReducer.embryoTransferDetails,
  );
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchSummary = async () => {
      const response = await fetchEmbryologyTransferData(
        data.selectedPatientData.patient.id,
        cycleId,
      );
      if (!response.data.result) {
        return;
      }
      dispatch(
        setEmbryologyData(
          'embryoTransferDetails',
          response.data.result.details,
        ),
      );
      dispatch(
        setEmbryologyData('embryoTransferDetails.id', response.data.result.id),
      );
      toast.success('Data fetched');
    };
    fetchSummary();
  }, []);
  const handleInputChange = (e) => {
    if (isDisabled) return;
    const { name, value } = e.target;
    dispatch(setEmbryologyData(`embryoTransferDetails.${name}`, value));

    if (name === 'transfer') {
      if (value === 'Self') {
        dispatch(setEmbryologyData(`embryoTransferDetails.surrogateName`, ''));
        dispatch(setEmbryologyData(`embryoTransferDetails.surrogateAge`, ''));
        dispatch(
          setEmbryologyData(`embryoTransferDetails.surrogateAadharNumber`, ''),
        );
        dispatch(setEmbryologyData(`embryoTransferDetails.surrogateMPI`, ''));
      }
    }
  };
  const handleGenderChange = (e, i, n, index) => {
    if (isDisabled) return;
    const { name, value } = e.target;
    embryoTransferDetails.gender[index] = value;
    dispatch(
      setEmbryologyData(
        `embryoTransferDetails.${name}`,
        embryoTransferDetails.gender,
      ),
    );
  };

  const handleAddRow = () => {
    if (isDisabled) return;
    const copyRows = [...embryoTransferDetails.embryoTransferredData];
    copyRows.push(embryoTransferredDataRow);
    dispatch(
      setEmbryologyData(
        'embryoTransferDetails.embryoTransferredData',
        copyRows,
      ),
    );
  };

  const setUploadedFiles = (files) => {
    dispatch(setEmbryologyBiopsyFiles(files));
  };

  const handleRowInputChange = (e, index) => {
    if (isDisabled) return;
    const { name, value } = e.target;
    const copyRows = embryoTransferDetails.embryoTransferredData.map(
      (item) => ({ ...item }),
    );
    copyRows[index][name] = value;
    dispatch(
      setEmbryologyData(
        'embryoTransferDetails.embryoTransferredData',
        copyRows,
      ),
    );
  };

  const handleTimeChange = (value, name) => {
    if (isDisabled) return;
    dispatch(setEmbryologyData(`embryoTransferDetails.${name}`, value));
  };

  const handleDeleteRow = (index) => {
    if (isDisabled) return;
    const copyRows = [...embryoTransferDetails.embryoTransferredData];
    copyRows.splice(index, 1);
    dispatch(
      setEmbryologyData(
        'embryoTransferDetails.embryoTransferredData',
        copyRows,
      ),
    );
  };

  const handleDateChange = (day, name) => {
    if (isDisabled) return;
    dispatch(setEmbryologyData(`embryoTransferDetails.${name}`, day));
  };
  const handleAdditionalRequirementChange = (e, index) => {
    if (isDisabled) return;
    const { checked } = e.target;
    const updatedCheckboxes = embryoTransferDetails.additionalRequirement.map(
      (item, idx) => (idx === index ? { ...item, checked } : item),
    );
    if (e.target.name === 'otherValue') {
      dispatch(
        setEmbryologyData(
          'embryoTransferDetails.additionalRequirementOther',
          e.target.value,
        ),
      );
    } else {
      dispatch(
        setEmbryologyData(
          `embryoTransferDetails.additionalRequirement`,
          updatedCheckboxes,
        ),
      );
    }
  };

  return (
    <div className="embryology-table">
      <h3 style={{ textAlign: 'center' }}>Fresh Embryo Transfer Details</h3>
      <EmbryologyBasicTransferDetails
        handleDateChange={handleDateChange}
        embryoTransferDetails={embryoTransferDetails}
        handleInputChange={handleInputChange}
        handleTimeChange={handleTimeChange}
        handleAdditionalRequirementChange={handleAdditionalRequirementChange}
      />
      <button
        className="btn btn-primary"
        style={{ width: '200px', marginBottom: '20px' }}
        onClick={handleAddRow}
      >
        Add Row
      </button>
      <div className="card">
        <div className="body" style={{ display: 'flex', gap: '10px' }}>
          <table
            style={{ flexGrow: 1, padding: '0px 10px' }}
            cellPadding={'10px'}
          >
            <thead>
              <tr>
                <th>No. of Embryos Transferred</th>
                <th>Code of the Embryo</th>
                <th>Day of Embryo Culture</th>
                <th>Embryo Grade</th>
              </tr>
            </thead>
            <tbody>
              {embryoTransferDetails.embryoTransferredData.map((row, index) => (
                <tr key={index}>
                  <td>
                    <CustomTextField
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      value={row.embryoNumber}
                      name={'embryoNumber'}
                      onChange={(e) => handleRowInputChange(e, index)}
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  </td>
                  <td>
                    {renderInputFieldWithoutLabel('code', row.code, (e) =>
                      handleRowInputChange(e, index),
                    )}
                  </td>
                  <td>
                    {renderInputFieldWithoutLabel('culture', row.culture, (e) =>
                      handleRowInputChange(e, index),
                    )}
                  </td>
                  <td>
                    {renderInputFieldWithoutLabel('grade', row.grade, (e) =>
                      handleRowInputChange(e, index),
                    )}
                  </td>

                  <td style={{ margin: 0, padding: 0 }}>
                    <button
                      style={{ marginTop: '-20px' }}
                      className="btn btn-danger"
                      disabled={
                        embryoTransferDetails.embryoTransferredData.length === 1
                      }
                      onClick={() => setConfirmModal({ open: true, index })}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <EmbryologyDetailsWithEmbryologist
        embryoTransferDetails={embryoTransferDetails}
        handleInputChange={handleInputChange}
      />

      <EmbryologyET
        embryoTransferDetails={embryoTransferDetails}
        handleInputChange={handleInputChange}
      />

      <h3 style={{ textAlign: 'center' }}>PREGNANCY AND OUTCOME</h3>
      <EmbryologyHormonalPregDetails
        embryoTransferDetails={embryoTransferDetails}
        handleInputChange={handleInputChange}
      />

      <EmbryologyClinicalPregDetails
        embryoTransferDetails={embryoTransferDetails}
        handleInputChange={handleInputChange}
      />

      <EmbryologyLiveBirthDetails
        embryoTransferDetails={embryoTransferDetails}
        handleInputChange={handleInputChange}
        handleGenderChange={handleGenderChange}
      />
      <UIModal
        title="Please confirm?"
        body="Are you sure you want to delete this record?"
        proceedText="Confirm"
        cancelText="Cancel"
        show={confirmModal.open}
        onClose={() => setConfirmModal({ open: false, index: null })}
        onSave={() => {
          handleDeleteRow(confirmModal.index);
          setConfirmModal({ open: false, index: null });
        }}
      />
    </div>
  );
};

export default EmbryologyTransferDetails;
